export default __webpack_public_path__ + "975e3a3204181503d1b0d6e734e96315.svg";